import { mapState } from 'pinia'
import { useRootStore } from 'client/stores/root'

const hasFeature = {}

hasFeature.install = function(Vue) {
  Vue.mixin({
    computed: {
      ...mapState(useRootStore, {
        features: '__features'
      })
    },
    methods: {
      $hasFeature(name) {
        return this.features[name]
      }
    }
  })

}

export default hasFeature

